import React from "react";

export default function Header(){
  return (
    <div className="header-container">
      <h2 className="header-title">PaperPusher</h2>
      <img src={require("../airplane.png")} alt=""  className="header-logo"/>
    </div>
  )
}